import { render } from "./HolderAnalyticsCharts.vue?vue&type=template&id=5b11db54&scoped=true"
import script from "./HolderAnalyticsCharts.vue?vue&type=script&lang=js"
export * from "./HolderAnalyticsCharts.vue?vue&type=script&lang=js"

import "./HolderAnalyticsCharts.vue?vue&type=style&index=0&id=5b11db54&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b11db54"],['__file',"resources/js/components/HolderAnalyticsCharts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b11db54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b11db54', __exports__)) {
    api.reload('5b11db54', __exports__)
  }
  
  module.hot.accept("./HolderAnalyticsCharts.vue?vue&type=template&id=5b11db54&scoped=true", () => {
    api.rerender('5b11db54', render)
  })

}


export default __exports__